<template>
  <div class="selectCustomerStyle">
    <v-autocomplete
      v-model="inputValue"
      multiple
      item-text="label"
      item-value="value"
      :items="createCustomerSelectBoxValueFrom(customerList)"
      dense
      outlined
      return-object
      class="original-selectbox"
      hide-details
      :placeholder="$t('common.input_unselected_2')"
      clearable
      :height="height"
      :disabled="disabled"
      :filled="disabled"
      :menu-props="{ closeOnContentClick: false }"
      :no-data-text="$t('common.common_no-data')"
      @input="searchInput = null"
      :search-input.sync="searchInput"
    >
      <template v-slot:selection="{ index }">
        <div v-if="index === 0" class="selectedItem">
          {{ selectedList }}
        </div>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    //
  },
  props: {
    value: {
      type: Array,
      require: false,
      default: () => []
    },
    height: {
      type: String,
      require: false,
      default: '32px'
    },
    disabled: { default: false }
  },
  data: () => ({
    searchInput: null,
    customerList: []
  }),
  created() {
    this.init()
  },
  methods: {
    ...mapActions('Customer', ['getCustomersFromApi']),
    ...mapGetters('Customer', ['getCustomerListFromState']),
    init() {
      this.getCustomerList()
    },
    async getCustomerList() {
      await this.getCustomersFromApi({ isHideUnusedCustomer: 1 })
      this.customerList = this.getCustomerListFromState()
    },
    createCustomerSelectBoxValueFrom(customerList) {
      if (customerList) {
        return customerList.map((ele) => {
          return {
            value: ele.customerId,
            label: ele.rep
          }
        })
      }
      return []
    }
  },
  computed: {
    selectedList() {
      return this.inputValue.map((item) => item.label).join(',')
    },
    inputValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.selectCustomerStyle {
  width: 100%;
  &::v-deep {
    .v-select__selections {
      display: flex; // 追加
      flex-wrap: nowrap; // 追加
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .selectedItem {
      // flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      // & + input {
      //   flex: 0;
      //   &:focus {
      //     flex: 1;
      //   }
      // }
    }
  }
}
</style>
